import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const routes = {
    path: '',
    component: () =>
        import('../../../layouts/main/Main.vue'),
    children: [
        {
            path: '/indicators/date-report',
            name: 'indicators-date-report',
            beforeEnter: (to, from, next) => {
                const hasPermission = localStorage.getItem('systems').includes(to.path);
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated) next('/pages/login')
                if (hasPermission) next()
                else next('/forbidden')

            },
            component: () =>
                import('./reports/date/date.vue')
        },
        {
            path: '/indicators/customers-report',
            name: 'indicators-customers-report',
            beforeEnter: (to, from, next) => {
                const hasPermission = localStorage.getItem('systems').includes(to.path);
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated) next('/pages/login')
                if (hasPermission) next()
                else next('/forbidden')

            },
            component: () =>
                import('./reports/customers/customers.vue')
        },
        {
            path: '/indicators/service-network-report',
            name: 'indicators-service-network-report',
            beforeEnter: (to, from, next) => {
                const hasPermission = localStorage.getItem('systems').includes(to.path);
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated) next('/pages/login')
                if (hasPermission) next()
                else next('/forbidden')

            },
            component: () =>
                import('./reports/service-network-report/service-network-report.vue')
        },
    ]
}
export default [
    routes
]

